function deactivateButton(buttonElements: NodeListOf<HTMLButtonElement>) {
  for (const button of buttonElements) {
    button.classList.remove('btn-secondary')
    button.classList.add('btn-light')
  }
}

function activateButton(
  activateButton: HTMLButtonElement,
  buttonElements: NodeListOf<HTMLButtonElement>,
) {
  deactivateButton(buttonElements)
  activateButton.classList.remove('btn-light')
  activateButton.classList.add('btn-secondary')
}

function populateDateRange(button: HTMLButtonElement) {
  if (button.dataset.fromSelector) {
    const fromElement = document.querySelector(
      button.dataset.fromSelector,
    ) as HTMLInputElement
    fromElement.value = button.dataset.fromValue ?? ''
  }
  if (button.dataset.toSelector) {
    const toElement = document.querySelector(
      button.dataset.toSelector,
    ) as HTMLInputElement
    toElement.value = button.dataset.toValue ?? ''
  }
}

export function configureDateRangeFilters() {
  const buttonElements =
    document.querySelectorAll<HTMLButtonElement>('.date-range-button')
  const clearButton = document.getElementById(
    'clear-date-range-button',
  ) as HTMLButtonElement

  for (const button of buttonElements) {
    button.addEventListener('click', function (event) {
      // Prevent dropdown closing on button click.
      event.stopPropagation()
      activateButton(button, buttonElements)
      populateDateRange(button)
    })
  }
  if (clearButton) {
    clearButton.addEventListener('click', function (event) {
      event.stopPropagation()
      deactivateButton(buttonElements)
      populateDateRange(clearButton)
    })
  }
}
